export default __webpack_public_path__ + "static/media/arrow-up.0c75c677.svg";